<template>
  <div class="blocked_logs_page">
    <h1>二筛主播池</h1>
    <div class="user-options clearfix">
      激活时间:
      <el-date-picker
        v-model="platformData"
        type="daterange"
        align="right"
        unlink-panels
        style="width: 280px"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="retainedOptions"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      修改时间:
      <el-date-picker
        style="width: 280px"
        v-model="platformData_"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="retainedOptions"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      主播状态:
      <el-select style="width: 160px" v-model="hostStatus" placeholder>
        <el-option
          v-for="(item, itemIndex) in hostStatuss"
          v-bind:key="itemIndex + 99"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <div class="user-options clearfix">
      国家:
      <el-select style="width: 160px" v-model="country" placeholder>
        <el-option
          v-for="(item, itemIndex) in countryList"
          v-bind:key="itemIndex + 99"
          :label="item.country"
          :value="item.countryCode"
        ></el-option>
      </el-select>
      代理id:
      <el-input
        style="width: 160px"
        v-model="agentId"
        placeholder="请输入代理id"
      ></el-input>
      rid:
      <el-input
        style="width: 160px"
        v-model="rid"
        placeholder="请输入rid"
      ></el-input>

      <el-button type="primary" @click="get_list" :loading="login1"
        >查询</el-button
      >
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <el-row>
      <el-table :data="tableList" height="80vh" border v-loading="login1">
        <el-table-column
          type="index"
          width="100"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column
          align="center"
          width="130"
          prop="rid"
          label="主播id"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="130"
          prop="head"
          label="主播头像"
          sortable
        >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.head"
              :preview-src-list="[scope.row.head]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="130"
          prop="name"
          label="主播昵称"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="130"
          prop="country"
          label="国家"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="130"
          prop="agentName"
          label="代理名"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="130"
          prop="agentId"
          label="代理id"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="130"
          prop="hostStatus"
          label="状态"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="130"
          prop="score"
          label="二筛评级"
          sortable
        >
          <template slot-scope="scope">
            <el-popover width="800" placement="bottom" trigger="click">
              <div class="tab">
                <div>
                  <div>维度</div>
                  <div>平均通话时长</div>
                  <div>礼物率</div>
                  <div>复播率</div>
                  <div>延续率</div>
                  <div>不服务率</div>
                </div>
                <div>
                  <div>结果</div>
                  <div>{{ scope.row.avgCallDuration }}</div>
                  <div>{{ scope.row.giftIncomeRate }}</div>
                  <div>{{ scope.row.redialRate }}</div>
                  <div>{{ scope.row.exceedCallRate }}</div>
                  <div>{{ scope.row.nonServiceRate }}</div>
                </div>
                <div>
                  <div>得分</div>
                  <div>{{ scope.row.avgCallDurationScore }}</div>
                  <div>{{ scope.row.giftIncomeRateScore }}</div>
                  <div>{{ scope.row.redialRateScore }}</div>
                  <div>{{ scope.row.exceedCallTimeScore }}</div>
                  <div>{{ scope.row.nonServiceRateScore }}</div>
                </div>
                <div>
                  <div>权重</div>
                  <div>{{ scope.row.avgCallDurationWeights }}</div>
                  <div>{{ scope.row.giftIncomeRateWeights }}</div>
                  <div>{{ scope.row.redialRateWeights }}</div>
                  <div>{{ scope.row.exceedCallRateWeights }}</div>
                  <div>{{ scope.row.nonServiceRateWeights }}</div>
                </div>
                <div>
                  <div>总分</div>
                  <p>{{ scope.row.score }}</p>
                </div>
                <div>
                  <div>考核分规则</div>
                  <p>{{ scope.row.scoreRule }}</p>
                </div>
              </div>
              <el-button type="primary" slot="reference" plain>
                查看详情
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="matchChatCount"
          label="二筛通话数"
          width="130"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="chatListVO"
          label="通话记录"
          width="130"
          sortable
        >
          <template slot-scope="scope">
            <div>{{ scope.row.chatListVO.count }}</div>
            <el-button type="primary" @click="xx(scope.row.chatListVO.list)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="hostLevel"
          align="center"
          label="主播当前等级"
          width="180"
        >
          <template slot-scope="scope">
            {{ level_(scope.row.hostLevel) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="dailyGuaranteedMaxDollar"
          label="每日保收限额"
          width="130"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="totalGuaranteeMaxDollar"
          label="总保收限额"
          width="130"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="activationTime"
          label="激活时间"
          width="130"
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="130"
          prop="mtime"
          label="修改时间"
          sortable
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <div class="juzhong">
              <el-button
                style="margin:0 0 20px"
                type="primary"
                @click="adopt_reject(scope.row)"
                size="medium"
                >等级修改</el-button
              >
            </div>
            <div v-if="host" class="juzhong">
              <el-button
                type="primary"
                @click="adopt_reject_(scope.row)"
                size="medium"
                >保收修改</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="10"
      ></el-pagination>
    </el-row>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible1"
      width="30%"
      :before-close="handleClose"
    >
      <div class="okay" v-if="!operator">
        <div>
          <span>rid:</span>
          <el-input
            style="width:150px"
            v-model="row_.rid"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div>
          <span>level:</span>
          <el-select
            style="width:150px"
            v-model="row_.level"
            placeholder="请选择"
          >
            <el-option
              v-for="item in levels"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <span>备注:</span>
          <el-input
            type="textarea"
            :rows="2"
            style="width:150px"
            v-model="row_.operatorDesc"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div>
          <span>时长(小时):</span>
          <el-input
            style="width:150px"
            v-model="row_.hour"
            placeholder="请输入内容"
          ></el-input>
        </div>
      </div>
      <div class="okay" v-if="operator">
        <div>
          <span>rid:</span>
          <el-input
            style="width:150px"
            v-model="update.rid"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div>
          <span>日保收限额:</span>
          <el-input
            style="width:150px"
            v-model="update.dayGuaranteeQuota"
            placeholder="请输入"
          ></el-input>
        </div>
        <div>
          <span>总保收限额:</span>
          <el-input
            style="width:150px"
            v-model="update.totalGuaranteeQuota"
            placeholder="请输入"
          ></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" v-if="!operator" @click="_gethostlevel"
          >确 定</el-button
        >
        <el-button type="primary" v-if="operator" @click="guarantee_config_"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <el-table :data="scope" height="75vh" stripe border>
        <el-table-column type="index" fixed label="No"> </el-table-column>
        <el-table-column
          align="center"
          property="rid"
          label="主播id"
        ></el-table-column>
        <el-table-column
          align="center"
          property="actorRid"
          label="用户id"
        ></el-table-column>
        <el-table-column
          align="center"
          property="userCountry"
          label="用户国家"
        ></el-table-column>
        <el-table-column
          align="center"
          property="userLang"
          label="用户语言"
        ></el-table-column>
        <el-table-column
          align="center"
          property="giftValue"
          label="通话礼物数"
        ></el-table-column>
        <el-table-column
          align="center"
          property="chatTime"
          label="通话时长"
        ></el-table-column>
        <el-table-column
          align="center"
          property="chatDate"
          label="通话时间"
        ></el-table-column>

        <el-table-column align="center" prop="videoUrl" label="通话视频url">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.videoUrl"
              class="name"
              type="primary"
              @click="look(scope.row.videoUrl)"
            >
              播放
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div v-show="vid" class="po" style="z-index:9999">
      <i @click="look_()" class="el-icon-circle-close pos"></i>
      <video
        id="video"
        preload="auto"
        muted
        size="medium"
        type="application/x-mpegURL"
        src=""
        controls
        class="video-js  vjs-default-skin  vjs-big-play-centered"
      >
        <!-- <source src="http://video.kissu.mobi/video/ag_record/test/60000456/2021-11-26/7107ce100041fd0ae753fd8d0a01ad93_61a049045bc237531c35407b.m3u8"  /> -->
      </video>
    </div>
  </div>
</template>

<script>
import download from '@/utils/download.js'
import { getCountry } from '@/utils/normalApi.js'
import { datainfor } from '@/utils/formdata.js'
import videojs from 'video.js'
import 'videojs-contrib-hls'
export default {
  data() {
    return {
      visible: false,
      index_: '',
      vid: false,
      row: [],
      row_: [],
      update: {},
      levels: [
        {
          label: 'L0',
          value: 0
        },
        {
          label: 'L1',
          value: 1
        },
        {
          label: 'L2',
          value: 2
        },
        {
          label: 'L3',
          value: 3
        }
      ],
      login1: false,
      dialogVisible_1: false,
      dialogVisible1: false,
      dialogVisible: false,
      platformData: [datainfor(6), datainfor(0)],
      platformData_: ['', ''],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      agentId: '',
      loading: true,
      country: 'total',
      countryList: '',
      page: 1,
      total: 0,
      rid: '',
      hostStatus: 3,
      hostStatuss: [
        {
          label: '二筛完成',
          value: 3
        },
        {
          label: '二筛中',
          value: 6
        }
      ],

      host: false,
      src: '',
      scope: [],
      operator: false
    }
  },
  beforeCreate() {},
  created() {
    this.getCountry_()
    this.get_list()
  },
  mounted() {},
  methods: {
    xx(scope) {
      this.dialogVisible = true
      this.scope = scope
    },
    level_(row) {
      let a = {
        0: 'L0',
        1: 'L1',
        2: 'L2',
        3: 'L3'
      }
      return a[row]
    },
    getVideo() {
      videojs(
        'video',
        {
          bigPlayButton: true,
          textTrackDisplay: false,
          posterImage: false,
          errorDisplay: false,
          controls: true,
          hls: {
            withCredentials: true
          }
        },
        function() {
          this.play()
        }
      )
    },
    look_() {
      this.vid = false
      var myPlayer = videojs('video') //获取video的id值
      myPlayer.pause()
    },
    look(url) {
      this.vid = true
      var myPlayer = videojs('video') //获取video的id值
      myPlayer.src(url)
      myPlayer.load(url)
      myPlayer.play()
      let playPromise = myPlayer.play()
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setTimeout(() => {
              myPlayer.play()
            }, 350)
          })
          .catch(() => {})
      }
    },
    async getCountry_() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    adopt_reject(row) {
      this.row_ = {
        rid: row.rid,
        level: row.hostLevel,
        operatorDesc: '',
        hour: row.hour
      }
      this.dialogVisible1 = true
      this.operator = false
    },
    adopt_reject_(row) {
      this.update = {
        rid: row.rid,
        dayGuaranteeQuota: row.dailyGuaranteedMaxDollar,
        totalGuaranteeQuota: row.totalGuaranteeMaxDollar
      }
      this.dialogVisible1 = true
      this.operator = true
    },
    async _gethostlevel() {
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.gethostlevel,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid: this.row_.rid,
          level: this.row_.level,
          hostType: 4,
          hour: this.row_.hour,
          operatorDesc: this.row_.operatorDesc
        }
      })
      if (res.data.code != 0) return this.$message(res.data.msg)
      this.$message.success(res.data.msg)
      this.get_list()
      this.dialogVisible1 = false
    },
    async get_list() {
      if (this.platformData == null) {
        this.platformData = ['', '']
      }
      if (this.platformData_ == null) {
        this.platformData_ = ['', '']
      }
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'post',
        url:
          this.$store.getters.path.second_exam_keep +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          time: this.platformData_[0],
          finish: this.platformData_[1],
          countryCode: this.country,
          agentId: this.agentId,
          hostStatus: this.hostStatus,
          rid: this.rid,
          page: this.page
        }
      })
      if (res !== null) {
        this.login1 = false
        this.tableList = res.data.data
        this.total = res.data.total
        if (this.hostStatus == 3) {
          this.host = true
        } else {
          this.host = false
        }
      }
    },
    async guarantee_config_() {
      const { data: res } = await this.$axios({
        method: 'post',
        url:
          this.$store.getters.path.guarantee_config +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        data: {
          rid: this.update.rid,
          dayGuaranteeQuota: this.update.dayGuaranteeQuota,
          totalGuaranteeQuota: this.update.totalGuaranteeQuota,
          operator: this.$store.getters.username
        }
      })
      if (res !== null) {
        this.dialogVisible1 = false
        this.get_list()
      }
    },
    xiangq(row) {
      this.row = row
      this.dialogVisible_1 = true
    },
    // 分页
    handleCurrentChange(num) {
      this.page = num
      this.get_list()
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'post',
        url:
          this.$store.getters.path.second_exam_download +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        data: {
          start: this.platformData[0],
          end: this.platformData[1],
          time: this.platformData_[0],
          finish: this.platformData_[1],
          countryCode: this.country,
          agentId: this.agentId,
          hostStatus: this.hostStatus,
          rid: this.rid,
          page: this.page
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '二次考核' + '')
    },

    closeSelectGiftDialogs() {
      this.dialogVisible_1 = false
    },
    handleClose1() {
      this.dialogVisible_1 = false
    },
    handleClose() {
      this.row = {}
      this.dialogVisible1 = false
      this.dialogVisible = false
      this.vid = false
    }
  }
}
</script>

<style lang="scss" scoped>
.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
.hover_ {
  display: flex;
  margin: 0 0 20px;

  span {
    width: 200px;
  }
}
.tab {
  text-align: center;
  > div {
    display: flex;
    margin: 0 0 10px;
    > div {
      width: 130px;
    }
    > p {
      flex: 1;
      padding: 0 20px;
      text-align: center;
    }
  }
}

.okay {
  > div {
    display: flex;
    align-items: center;
    margin: 0 0 10px;
    > span {
      width: 100px;
    }
  }
}
.po {
  width: 480px;
  height: 640px;
  position: absolute;
  left: 20%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.pos {
  position: absolute;
  top: 10px;
  right: -50px;
  transform: scale(2);
}
</style>
